export const LOGIN_USER = 'LOGIN_USER';
export const LOG_OUT = 'LOG_OUT';

export const setUser = user => ({
  type: LOGIN_USER,
  user,
});

export const logout = () => ({ type: LOG_OUT });
